import React, { useState, useEffect } from 'react';
import { focusAreas, eventStats, Bannerpartners, verticals } from '../data/conclaveData';
import CSI_white from '../media/uploads/CSI_whitenew.png';
import TechTrust_Logo from '../media/uploads/STTC_Logo_New_Test.png';
// import TechTrust_Logo from '../media/uploads/TechTrust_Logo-tran.png';
import SKL_Logo_white from '../media/uploads/SKL_Logo_white.png';
import { MapPin, CalendarDays } from 'lucide-react';
import bgImage from '../media/uploads/bgSTTC_New.jpg';
import { useModal } from '../context/ModalContext';
import { scrollToSection } from '../utils/dataUtils';

import Countdown from '../components/Countdown';


const getInvolved = "get-involved";


function CountdownTimer() {
  const calculateTimeLeft = () => {
    const targetIST = new Date('2026-01-21T08:00:00+05:30'); // Correct IST time
    const nowUTC = new Date(); // current time (in system timezone, but we'll compare as milliseconds)
    const difference = targetIST.getTime() - nowUTC.getTime();
    if (difference <= 0) return null;

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!timeLeft) {
    return (
      <div className="p-[2px] bg-gradient-to-r from-primary to-secondary inline-block rounded-xl mr-4">
        <div className="pt-2 pb-2 px-6 bg-[#140F30] rounded-xl text-center">
          <p className="text-lg font-bold text-white">Event Started!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-[2px] bg-[linear-gradient(93.84deg,#EA5133_0%,#5744B1_100%)] inline-block rounded-xl mr-4">
      <div className="pt-2 pb-2 pl-4 pr-4 bg-[#140F30] rounded-xl text-center">
        <p className="text-sm font-semibold text-white">
          {timeLeft.days}D {timeLeft.hours}h:{timeLeft.minutes}m:{timeLeft.seconds}s
        </p>
        <p className="text-xs text-white">Until Launch</p>
      </div>
    </div>
  );
}

export default function Hero({ setInvolvedIndex }) {
  const { openModal } = useModal();
  const handleClick = () => {
    setInvolvedIndex(0); // or any index you want to send
    scrollToSection(getInvolved)
    //openModal('delegates')
  };

  return (
    <section id="home"
      className="pt-12 relative  relative  bg-gradient-to-br from-darkbg via-midbg to-lightbg overflow-hidden bg-cover bg-center bg-transparent"
      style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className=" flex items-start relative z-10 mt-20 sm:mt-24 3xl:mt-48 px-3 md:pl-80 md:pr-20 mx-auto w-full max-w-[1728px] flex items-start">


        <div className={window.innerWidth < 768 ? "block justify-around items-center items-center w-full" : "flex justify-around items-start w-full -mt-3"}>
          {/* Left Content */}
          <div className='block md:flex w-full md:w-[90%]'>


            <div>
              <div className='flex items-center  justify-center mb-4  w-[95%] mx-auto 3xl:ml-auto'>

                <img src={TechTrust_Logo} className='w-[50%] ' />

              </div>

              <p className="italic text-pink-400 font-bold text-sm md:text-lg  w-full text-center mb-6">Uniting minds to lead emerging technologies in defence tech in line with PM’s vision of VIKSIT Bharat.</p>
              <div className='block md:flex items-start  justify-around mt-6 md:mt-6 3xl:mt-8  w-[95%] mx-auto 3xl:ml-auto'>
                <div className='mr-0  w-[90%]  md:w-[35%] mb-4 md:mb-0'>
                  <p className="text-white/80 text-sm  text-center  md:mb-8">Hosted by</p>
                  <img src={CSI_white} className='w-[70%] max-h-24 md:w-[90%] mx-auto' />
                </div>
                <div className='md:w-[50%] mb-4 md:mb-0 md:bg-[rgba(42,10,34,0.3)]'>
                  <p className="text-white/80 text-sm  mb-5 text-center  ">Co-Hosting Partners</p>
                  {Bannerpartners
                    .filter(x => x.title === 'Co-Hosted By')
                    .sort((a, b) => a.order - b.order)
                    .map((stat, index) => (
                      <div key={index} className="flex md:flex-wrap gap-6 justify-center items-center mx-auto">
                        {stat.entries
                          .sort((a, b) => a.order - b.order)
                          .map((x, i) => (
                            <div
                              key={i}
                              className="w-[20%]    flex items-center justify-center  shadow-md hover:shadow-lg transition"
                            >
                              <img
                                src={x.logo}
                                alt={x.name || 'Partner Logo'}
                                className="max-h-24 max-w-[90%] object-contain "
                              />
                            </div>
                          ))}</div>))}
                </div>
                <div className='ml-0  mb-0 w-auto mb-4  md:w-[25%] md:mb-0'>
                  <p className="ml-0 md:ml-[2.40rem] text-white/80 text-sm  text-center md:text-start mb-2 ">Curated & Powered by</p>
                  <img src={SKL_Logo_white} className='mx-auto md:w-[70%] md:mx-auto' />
                </div>
              </div>
              <div className=' block md:flex items-center justify-evenly mt-6 md:mt-0 3xl:mt-8 w-[95%] mx-auto 3xl:ml-auto'>
                <div className='flex items-center justify-center mt-8 mb-8'>
                 
                  <Countdown target="2026-01-21T08:00:00+05:30" />
                 
                  <div>
                    <div className='font-bold flex items-center  mb-2'>
                      <CalendarDays /> <span className='ml-3'>January 21, 2026</span>
                    </div>
                    <div className=' flex items-center justify-center'>
                      <MapPin /> <span className='ml-3'>Taj MG Road - Trinity Hall, Bengaluru</span>
                    </div>
                  </div>

                </div>
                <div className='block'>
                  {/* <div>
                     <button className="text-white px-8 py-2 w-full mb-3 md:mb-0  rounded-full btn-background "
                      onClick={handleClick}
                    >
                      Register
                    </button> 
                  </div>*/}
                  {/* <button className="p-[2px] w-full mb-3 md:mb-0 mt-3  bg-[linear-gradient(93.84deg,#EA5133_0%,#5744B1_100%)] inline-block rounded-full" onClick={() => openModal('sponsorship')}>
                    <div className="pt-2 pb-2 pl-6 pr-6 bg-[#140F30] rounded-full text-center">Let's Partner</div>
                  </button> */}
                </div>
              </div>
            </div>


          </div>

          {/* Enhanced Stats Grid */}
          <div className="flex md:block grid grid-cols-2 w-full md:w-[10%] md:mt-8">
            {eventStats.filter(stat => stat.display).sort((a, b) => a.order - b.order).map((stat, index) => (
              <div className='glass-effect-strong rounded-3xl px-3 py-2 md:py-6 mb-3 w-[80%] md:w-[100%] text-center md:ml-auto '>
                <p className="text-xl md:text-3xl font-bold text-white">{stat.count}</p>
                <p className="text-xs text-white">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>


      </div>


      <div className={window.innerWidth < 768 ? "block justify-around items-center items-center mt-12" : "flex justify-between items-center items-center mt-6 mb-5 cursor-pointer"} onClick={() => scrollToSection('conclave-overview')}>
        <div className='w-full md:w-[45%] mt-2 md:mt-0'>
          <p className="text-base md:text-xl font-bold text-lavender mb-3 text-center md:text-center uppercase">Emerging Technologies</p>
          <div className="">
            <div className="w-full items-center justify-around relative">
              <div className="grid grid-cols-2 justify-center gap-4 md:flex  md:justify-between relative max-w-6xl">
                {/* <Slider {...settings}> */}
                {focusAreas.content
                  .filter(area => area.display)
                  .sort((a, b) => a.order - b.order)
                  .map((area, i) => {

                    const IconComponent = area.icon;
                    return (
                      <div className="flex justify-center md:justify-center w-full items-center md:justify-center md:w-1/4" key={i} >
                        <div>
                          <IconComponent className="w-full h-10  text-secondary" />
                          <h3 className="text-xs md:text:base font-bold text-white mb-4">{area.title}</h3>
                        </div>
                      </div>)
                  })
                }

                {/* </Slider> */}
              </div>
            </div>
          </div>
          {/* {Bannerpartners.filter(x=>x.title == 'Co-Hosted By').sort((a, b) => a.order - b.order).map((stat, index) => (
            <div className='flex  justify-between items-center'>
                {stat.entries.sort((a, b) => a.order - b.order).map((x, i) => (
                  <img src={x.logo} />
                ))}
            </div>
          ))} */}
        </div>
        <div className="w-[3px] md:h-18 bg-gradient-to-b from-[#ea5133] to-[#5744b1]" />

        <div className='w-full md:w-[40%]'>
          <p className="text-base md:text-xl text-center md:text-center font-bold text-lavender mb-3 uppercase">Industry Verticals</p>
          <div className="">
            <div className="w-full items-center justify-around relative">
              <div className="grid grid-cols-1 justify-center gap-4 md:flex   relative max-w-6xl">
                {/* <Slider {...settings}> */}
                {verticals.content
                  .filter(area => area.display)
                  .sort((a, b) => a.order - b.order)
                  .map((area, i) => {

                    const IconComponent = area.icon;
                    return (
                      <div className="flex justify-center w-full items-center md:justify-center md:w-1/2" key={i}>
                        <div>
                          <IconComponent className="w-full h-9  text-secondary" />
                          <h3 className="text-xs md:text:base font-bold text-white mb-4">{area.name}</h3>
                        </div>
                      </div>)
                  })
                }

                {/* </Slider> */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
